<template>
  <div class="block block_logic">
    <div class="block_head">逻辑设置</div>
    <div class="block_mod">
      <div
        v-if="question.setting"
        class="setting_item"
      >
        <div class="hd">
          <span class="hd_text">默认隐藏该题目</span>
          <el-switch
            v-model="question.setting.visibility.hidden"
            style="float:right;"
          >
          </el-switch>
          <div
            v-if="question.setting.visibility.hidden"
            class="visible"
          >
            <div class="title">
              选中下列
              <span
                class="logic"
                @click="toggleLogic"
              >{{ question.setting.visibility.visible.logic==='and'?"全部":"任一" }}
                <i
                  class="fa fa-caret-down"
                  aria-hidden="true"
                ></i>
              </span>
              选项，则显示该题：
            </div>
            <div class="options">
              <div
                v-for="(option,index) in selectedOptions"
                :key="index"
                class="option"
              >
                <span class="q-id">Q {{ option.qIndex+1 }}</span>
                <div class="text">
                  {{ option.text }}
                </div>
                <i
                  class="fa fa-trash-o"
                  aria-hidden="true"
                  @click="deleteOption(index)"
                ></i>
              </div>
              <div
                class="more"
                @click="addMore"
              >
                <i
                  class="fa fa-plus-circle"
                  aria-hidden="true"
                ></i> 添加更多条件
              </div>
            </div>
          </div>

          <el-dialog
            title="请选择要关联的题目的选项"
            :visible.sync="dialogVisible"
            width="500"
            :before-close="handleClose"
            :append-to-body="true"
          >
            <group-checkbox :questions="questionsBefore"></group-checkbox>
            <div class="notice">
              <i
                class="fa fa-question-circle"
                aria-hidden="true"
              ></i> 您只能选择要设置逻辑关系题目之前的题目选项
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GroupCheckbox from "./group-checkbox";
export default {
  props: {},
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    question: {
      get: function() {
        return this.$store.state.survey.activeQuestion;
      },
      set: function() {}
    },
    // 计算选中题目前面所有的题目
    questionsBefore() {
      return this.$store.state.survey.surveyBody.questions.slice(
        0,
        this.$store.state.survey.activeIndex
      );
    },

    // 根据 this.question.setting.visibility.visible.options 查询 带有 qIndex oId text 的数组
    selectedOptions() {
      /**
       * [{
       *  qIndex:1,
       *  oId:'1234545'
       *  text:''
       * }
       * ...
       * ]
       */
      let result = [];
      let options = this.question.setting.visibility.visible.options;

      this.questionsBefore.forEach((q, qIndex) => {
        q.options.forEach(op => {
          if (options.indexOf(op.id) >= 0) {
            result.push({
              qIndex: qIndex,
              oId: op.id,
              text: op.text
            });
          }
        });
      });
      return result;
    }
  },
  methods: {
    toggleLogic() {
      let preLogic = this.question.setting.visibility.visible.logic;
      this.question.setting.visibility.visible.logic =
        preLogic === "and" ? "or" : "and";
    },
    addMore() {
      this.dialogVisible = true;
    },
    // Dialog 关闭事件
    handleClose() {
      this.dialogVisible = false;
    },
    // 删除一个 option
    deleteOption(index) {
      this.question.setting.visibility.visible.options.splice(index, 1);
    }
  },
  components: {
    GroupCheckbox
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/style/variables.less";

.block_logic {
  margin-top: 30px;
}

.visible {
  padding: 10px 0;

  .title {
    font-size: 13px;

    .logic {
      cursor: pointer;
      color: @deepblue;
      font-weight: bold;
    }
  }

  .options {
    padding-top: 5px;

    .option {
      .q-id {
        background-color: #495165;
        padding: 3px;
        font-size: 10px;
        color: white;
        border-radius: 2px;
      }

      .text {
        display: inline-block;
        padding: 0 6px;
        width: 160px;
      }

      .fa.fa-trash-o {
        cursor: pointer;
        float: right;
        line-height: 24px;

        &:hover {
          color: #e83632;
        }
      }
    }

    .more {
      text-align: center;
      line-height: 300%;
      cursor: pointer;

      &:hover {
        font-weight: bold;
      }
    }
  }

  .choose-options {
    .q-title {
      height: 30px !important;
    }
  }
}

.notice {
  text-align: center;
  font-size: 12px;
  color: lightgray;
}
</style>